<template>
  <div class="tax-table-wrap" :class="[`tax-status-${taxData.status}`]" v-if="isInit">
    <dl class="tax-table-header">
      <dt>企业所得税汇总纳税分支机构所得税分配表</dt>

      <dd>
        <div>
          税款所属期：{{ staticConfig.taxStartTime }} ~ {{ staticConfig.taxEndTime }}<br />
          填报日期：{{ staticConfig.fillFormDate }}
        </div>

        <div>单位：元至角分</div>
      </dd>
    </dl>

    <div class="tax-table-body">
      <table>
        <tbody>
          <tr>
            <td colspan="2">应纳所得税额</td>
            <td>总机构分摊所得税额</td>
            <td colspan="3">总机构财政集中分配所得税额</td>
            <td colspan="2">分支机构分摊所得税额</td>
          </tr>
          <tr>
            <td colspan="2">{{ parseFloatNum(data.v1x1.value) }}</td>
            <td>{{ parseFloatNum(data.v1x2.value) }}</td>
            <td colspan="3">{{ parseFloatNum(data.v1x3.value) }}</td>
            <td colspan="2">{{ parseFloatNum(data.v1x4.value) }}</td>
          </tr>
          <tr>
            <th rowspan="16" class="title01">分支机构情况</th>
            <th rowspan="2" class="title01">分支机构纳税人识别号（统一社会信用代码）</th>
            <th rowspan="2" class="title01">分支机构名称</th>
            <th colspan="3" class="title01">三项因素</th>
            <th rowspan="2" class="title01">分配比例</th>
            <th rowspan="2" class="title01">分配所得税额</th>
          </tr>
          <tr>
            <th class="title01">营业收入</th>
            <th class="title01">职工薪酬</th>
            <th class="title01">资产总额</th>
          </tr>
          <tr class="tr">
            <td>
              <el-input-number v-model.trim="data.v2x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v2x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v2x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v2x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v2x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v2x6.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v2x7.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
          </tr>
          <tr class="tr">
            <td>
              <el-input-number v-model.trim="data.v3x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v3x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v3x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v3x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v3x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v3x6.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v3x7.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
          </tr>
          <tr class="tr">
            <td>
              <el-input-number v-model.trim="data.v4x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v4x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v4x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v4x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v4x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v4x6.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v4x7.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
          </tr>
          <tr class="tr">
            <td>
              <el-input-number v-model.trim="data.v5x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v5x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v5x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v5x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v5x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v5x6.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v5x7.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
          </tr>
          <tr class="tr">
            <td>
              <el-input-number v-model.trim="data.v6x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v6x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v6x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v6x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v6x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v6x6.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v6x7.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
          </tr>
          <tr class="tr">
            <td>
              <el-input-number v-model.trim="data.v7x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v7x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v7x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v7x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v7x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v7x6.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v7x7.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
          </tr>
          <tr class="tr">
            <td>
              <el-input-number v-model.trim="data.v8x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v8x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v8x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v8x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v8x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v8x6.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v8x7.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
          </tr>
          <tr class="tr">
            <td>
              <el-input-number v-model.trim="data.v9x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v9x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v9x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v9x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v9x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v9x6.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v9x7.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
          </tr>
          <tr class="tr">
            <td>
              <el-input-number v-model.trim="data.v10x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v10x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v10x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v10x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v10x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v10x6.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v10x7.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
          </tr>
          <tr class="tr">
            <td>
              <el-input-number v-model.trim="data.v11x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v11x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v11x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v11x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v11x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v11x6.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v11x7.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
          </tr>
          <tr class="tr">
            <td>
              <el-input-number v-model.trim="data.v12x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v12x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v12x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v12x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v12x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v12x6.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v12x7.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
          </tr>
          <tr class="tr">
            <td>
              <el-input-number v-model.trim="data.v13x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v13x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v13x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v13x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v13x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v13x6.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v13x7.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
          </tr>
          <tr class="tr">
            <td>
              <el-input-number v-model.trim="data.v14x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v14x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v14x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v14x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v14x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v14x6.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v14x7.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
          </tr>
          <tr class="tr">
            <td class="title01" colspan="2">合计</td>
            <td>
              {{ parseFloatNum(data.v15x1.value) }}
            </td>
            <td>
              {{ parseFloatNum(data.v15x2.value) }}
            </td>
            <td>
              {{ parseFloatNum(data.v15x3.value) }}
            </td>
            <td class="title01">--</td>
            <td class="title01">--</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<style scoped lang="scss">
.tax-table-wrap {
  width: 1200px !important;
}
</style>

<script setup>
import { cloneDeep } from "lodash";
import Big from "big.js";
import { reportTaxDateConfig } from "../../reportTaxStaticConfig.js";
import taxQue from "../../cmp/taxQue.vue";

const currentQa = inject("provideCurrentQa");
const staticConfig = computed(() => reportTaxDateConfig(currentQa.value).staticConfig);

const isInit = ref(false);
const mode = ref(null);

// 初始数据
const taxDataAll = ref({});
const taxData = ref({});
const data = ref({});
// 初始化
const init = (options = {}) => {
  mode.value = options.mode;
  taxDataAll.value = cloneDeep(options.taxDataAll);
  // 当前数据
  taxData.value = cloneDeep(options.taxData);
  // 当前数据的表单数据
  data.value = cloneDeep(options.taxData.data);
  watchStart();
  isInit.value = true;
};
// 返回数据
const getData = () => {
  if (!isInit.value) {
    return;
  }

  return toRaw(data.value);
};

function watchStart() {
  watch(data, (newVal, oldVal) => {}, {
    deep: true,
    immediate: true,
  });
}

// 小数点
function parseFloatNum(s, num = 2) {
  try {
    return new Big(s).toFixed(num);
  } catch (e) {}
}

defineExpose({
  init,
  getData,
});
</script>

<style scoped lang="scss">
.tax-table-wrap {
  width: 1050px !important;
}
</style>

<script>
const tableHtml = `
<table class="">
  <colgroup>
    <col width="50" />
    <col />
  </colgroup>
  <tbody>
    <tr>
      <td rowspan="3" class="td-center">行次</td>
      <td colspan="5" rowspan="3" class="td-center">项目</td>
      <td colspan="2" rowspan="2" class="td-center">本年享受优惠的资产原值</td>
      <td colspan="10" class="td-center">本年累计折旧\摊销（扣除）金额</td>
    </tr>
    <tr>
      <td colspan="2" class="td-center">账载折旧\摊销金额</td>
      <td colspan="2" class="td-center">按照税收一般规定计算的折旧\摊销金额</td>
      <td colspan="2" class="td-center">享受加速政策计算的折旧\摊销金额</td>
      <td colspan="2" class="td-center">纳税调减金额</td>
      <td colspan="2" class="td-center">享受加速政策优惠金额</td>
    </tr>
    <tr>
      <td colspan="2" class="td-center">1</td>
      <td colspan="2" class="td-center">2</td>
      <td colspan="2" class="td-center">3</td>
      <td colspan="2" class="td-center">4</td>
      <td colspan="2" class="td-center">5(4-2)</td>
      <td colspan="2" class="td-center">6(4-3)</td>
    </tr>
    <tr>
      <td class="td-center">1</td>
      <td colspan="3" class="td-center">一、加速折旧、摊销（不含一次性扣除，1.1+1.2+…）</td>
      <td><a href="javascript:void(0);" class="btn btn-sm">增加</a></td>
      <td><a href="javascript:void(0);" class="btn btn-sm">删除</a></td>
      <td colspan="2" class="td-center">
        <div class="grid-text"><input type="text" autocomplete="off" readonly="readonly" /></div>
      </td>
      <td colspan="2" class="td-center">
        <div class="grid-text"><input type="text" autocomplete="off" readonly="readonly" /></div>
      </td>
      <td colspan="2" class="td-center">
        <div class="grid-text"><input type="text" autocomplete="off" readonly="readonly" /></div>
      </td>
      <td colspan="2" class="td-center">
        <div class="grid-text"><input type="text" autocomplete="off" readonly="readonly" /></div>
      </td>
      <td colspan="2" class="td-center">
        <div class="grid-text"><input type="text" autocomplete="off" readonly="readonly" /></div>
      </td>
      <td colspan="2" class="td-center">
        <div class="grid-text"><input type="text" autocomplete="off" readonly="readonly" /></div>
      </td>
    </tr>
    <tr>
      <td class="td-center">2</td>
      <td colspan="3" class="td-center">二、一次性扣除（2.1+2.2+…）</td>
      <td><a href="javascript:void(0)" class="btn btn-sm">增加</a></td>
      <td><a href="javascript:void(0)" class="btn btn-sm">删除</a></td>
      <td colspan="2" class="td-center">
        <div class="grid-text"><input type="text" autocomplete="off" readonly="readonly" /></div>
      </td>
      <td colspan="2" class="td-center">
        <div class="grid-text"><input type="text" autocomplete="off" readonly="readonly" /></div>
      </td>
      <td colspan="2" class="td-center">
        <div class="grid-text"><input type="text" autocomplete="off" readonly="readonly" /></div>
      </td>
      <td colspan="2" class="td-center">
        <div class="grid-text"><input type="text" autocomplete="off" readonly="readonly" /></div>
      </td>
      <td colspan="2" class="td-center">
        <div class="grid-text"><input type="text" autocomplete="off" readonly="readonly" /></div>
      </td>
      <td colspan="2" class="td-center">
        <div class="grid-text"><input type="text" autocomplete="off" readonly="readonly" /></div>
      </td>
    </tr>
    <tr>
      <td colspan="6" class="td-center">合计（1+2）</td>
      <td colspan="2" class="td-center">
        <div class="grid-text"><input type="text" autocomplete="off" readonly="readonly" /></div>
      </td>
      <td colspan="2" class="td-center">
        <div class="grid-text"><input type="text" autocomplete="off" readonly="readonly" /></div>
      </td>
      <td colspan="2" class="td-center">
        <div class="grid-text"><input type="text" autocomplete="off" readonly="readonly" /></div>
      </td>
      <td colspan="2" class="td-center">
        <div class="grid-text"><input type="text" autocomplete="off" readonly="readonly" /></div>
      </td>
      <td colspan="2" class="td-center">
        <div class="grid-text"><input type="text" autocomplete="off" readonly="readonly" /></div>
      </td>
      <td colspan="2" class="td-center">
        <div class="grid-text"><input type="text" autocomplete="off" readonly="readonly" /></div>
      </td>
    </tr>
  </tbody>
</table>
`;

function replaceHtml(str) {
  let s = str.replace(/(<div([^>]*)>)|(<\/div>)/gi, "");
  s = s.replace(/(<span([^>]*)>)|(<\/span>)/gi, "");
  s = s.replace(/<input type="text" autocomplete="off" \/>/g, '<el-input-number v-model.trim="defaultValueNum" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.00" />');

  return s;
}

const defaultValueNum = ref(0);
// console.log(replaceHtml(tableHtml), "tableHtml");
</script>
